export default class Event {
  constructor(data) {
    this.id = data?.id ?? null;
    this.title = data?.title ?? '';
    this.description = data?.description ?? '';
    this.startDate = data?.start_date ?? null;
    this.endDate = data?.end_date ?? null;
    this.capacity = data?.capacity ?? 0;
    this.forecastedVisitorCount = data?.forecasted_visitor_count ?? null;
    this.isOnline = data?.is_online ?? false;
    this.status = data?.status ?? 'DRAFT';
    this.primaryOrganizerName = data?.primary_organizer_name ?? '-';
    this.additionalOrganizersCount = data?.additional_organizers_count ?? 0;
    this.minFee = data?.min_fee ?? null;
    this.maxFee = data?.max_fee ?? null;
    this.hasMultipleFees = data?.has_multiple_fees ?? false;
  }

  /**
   * Check if there are additional organizers.
   */
  get hasAdditionalOrganizers() {
    return this.additionalOrganizersCount > 0;
  }

  /**
   * Format the fee display text
   * e.g., "¥3,000" or "¥3,000〜" or "¥0"
   */
  get feeDisplayText() {
    if (this.minFee === null) {
      return '-';
    }
    const formattedFee = `¥${Math.floor(this.minFee).toLocaleString()}`;
    return this.hasMultipleFees ? `${formattedFee}〜` : formattedFee;
  }

  /**
   * Format the date range display text
   * e.g., "2025/10/28" or "2025/10/28-2025/10/30"
   */
  get dateRangeDisplayText() {
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    };

    const start = formatDate(this.startDate);
    const end = formatDate(this.endDate);

    if (start === end) {
      return start;
    }
    return `${start}-${end}`;
  }
}
